"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const TimerIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("path", { d: "M20 12C20 7.58172 16.4183 4 12 4V2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.9457 2.62053 8.0333 3.68454 6.44374C4.29169 5.53671 5.04326 4.73464 5.90662 4.07033L5.24142 2.91817C5.15233 2.76386 5.29428 2.57887 5.46639 2.62498L8.90489 3.54633C9.01158 3.57492 9.0749 3.68458 9.04631 3.79128L8.12497 7.22978C8.07885 7.40189 7.84767 7.43232 7.75858 7.27801L6.91766 5.8215C6.31341 6.31919 5.78326 6.90386 5.34656 7.55626C4.49602 8.8269 4 10.354 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z" }),
    react_1.default.createElement("path", { d: "M11 8H9V16H11V8Z" }),
    react_1.default.createElement("path", { d: "M15 8H13V16H15V8Z" })));
exports.TimerIcon = TimerIcon;
exports.default = exports.TimerIcon;
